<div class="splash">
    <div class="row align-items-center">
        <div class="col-sm-5 col-md-4 offset-md-2 col-lg-3 offset-lg-2">

            <div class="row">
                <div class="col">
                    <img src="images/deloitte.svg" alt="Deloitte" class="splash__logo mb-3" />
                </div>
            </div>

            <div class="row mb-5 pt-4">
                <div class="col">
                    <p class="splash__title">
                        {{displayName}}
                    </p>
                    <p class="text-muted textBody--md mt-0 mb-4">Reset your password</p>
                    <p class="text-muted textBody--sm mt-0 mb-4">Password needs to be at least 9 characters in length and a combination of at least 1 digit, 1 special character, 1 upper case character and 1 lower case character</p>
                    <form name="passwordResetForm" [formGroup]="passwordResetForm" novalidate>
                        <div class="form-group">
                            <label class="text-white" for="username">Email</label>
                            <input placeholder="Enter your email" class="form-control" name="username" type="text" formControlName="email" />
                            @if (passwordResetForm.controls['email'].hasError('required') && passwordResetForm.controls['email'].touched) {
                            <div class="alert alert-danger mt-3">You must include an email.</div>
                            }
                            @if (passwordResetForm.controls['email'].hasError('pattern') && passwordResetForm.controls['email'].touched) {
                            <div class="alert alert-danger mt-3">Email is invalid.</div>
                            }
                        </div>

                        <div class="form-group">
                            <label class="text-white" for="password">Password</label>
                            <input placeholder="Enter your password" class="form-control" name="password" type="password" formControlName="password" autocomplete="off" />
                            @if (passwordResetForm.controls['password'].hasError('required') && passwordResetForm.controls['password'].touched) {
                            <div class="alert alert-danger mt-3">You must include an password.</div>
                            }
                        </div>

                        <div class="form-group">
                            <label class="text-white" for="password">Confirm Password</label>
                            <input placeholder="Confirm your password" class="form-control" name="password" type="password" formControlName="confirmPassword" autocomplete="off" />
                            @if (passwordResetForm.controls['confirmPassword'].hasError('required') && passwordResetForm.controls['confirmPassword'].touched) {
                            <div class="alert alert-danger mt-3">You must include confirm password.</div>
                            }
                            @if (passwordResetForm.hasError('nomatch') && (passwordResetForm.controls['confirmPassword'].touched || passwordResetForm.controls['password'].touched)) {
                            <div class="alert alert-danger mt-3">Passwords do not match.</div>
                            }
                        </div>

                        <div class="form-group mt-4">
                            <button class="btn btn-block btn-info" type="submit" [disabled]="!passwordResetForm.valid" (click)="resetPasswordClicked(passwordResetForm.value)">
                                {{resettingPassword ? "Resetting password..." : "Reset password"}}
                                <i class="fa fa-sign-in"></i>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="col-sm-7 col-md-6">
            <div class="splash__image">
                <img src="/images/globe.jpg" />
            </div>
        </div>
    </div>
</div>
